import { motion } from 'framer-motion';
import { Navbar } from './Navbar';
import { Footer } from './Footer';

export const AcceptableUsePolicy = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="acceptable-use-page">
      <Navbar />
      <main className="pt-24 pb-20">
        <div className="section-container">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          >
            <span className="label-text text-[#6B7280] block mb-4">Legal</span>
            <h1 className="heading-lg text-3xl md:text-4xl lg:text-5xl text-[#1E3A5F] mb-8">
              Acceptable Use Policy
            </h1>
            <p className="text-[#6B7280] mb-8">Last updated: January 2026</p>
            
            <div className="prose prose-lg max-w-4xl text-[#4B5563]">
              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-[#1E3A5F] mb-4">1. Purpose</h2>
                <p className="mb-4">
                  This Acceptable Use Policy ("AUP") governs your use of Easysend's payment infrastructure 
                  services. By using our services, you agree to comply with this policy.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-[#1E3A5F] mb-4">2. Permitted Use</h2>
                <p className="mb-4">You may use our services for:</p>
                <ul className="list-disc pl-6 mb-4 space-y-2">
                  <li>Legitimate business payment processing</li>
                  <li>Cross-border transactions in supported currencies</li>
                  <li>Treasury and FX operations for business purposes</li>
                  <li>Account management and reconciliation</li>
                </ul>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-[#1E3A5F] mb-4">3. Prohibited Activities</h2>
                <p className="mb-4">You must not use our services for:</p>
                <ul className="list-disc pl-6 mb-4 space-y-2">
                  <li>Money laundering or terrorist financing</li>
                  <li>Fraud or any illegal activities</li>
                  <li>Transactions involving sanctioned persons or entities</li>
                  <li>Circumventing any applicable laws or regulations</li>
                  <li>Processing payments for illegal goods or services</li>
                  <li>Any activity that violates intellectual property rights</li>
                  <li>Transactions related to unlicensed gambling operations</li>
                  <li>Sale of illegal drugs or controlled substances</li>
                  <li>Human trafficking or exploitation</li>
                  <li>Weapons sales in violation of applicable laws</li>
                </ul>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-[#1E3A5F] mb-4">4. Restricted Industries</h2>
                <p className="mb-4">
                  The following industries require enhanced due diligence and prior approval:
                </p>
                <ul className="list-disc pl-6 mb-4 space-y-2">
                  <li>Cryptocurrency and digital asset businesses</li>
                  <li>Licensed gambling and gaming operators</li>
                  <li>Adult entertainment</li>
                  <li>Cannabis-related businesses (where legal)</li>
                  <li>Precious metals and stones dealers</li>
                  <li>Money service businesses</li>
                </ul>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-[#1E3A5F] mb-4">5. Compliance Requirements</h2>
                <p className="mb-4">You agree to:</p>
                <ul className="list-disc pl-6 mb-4 space-y-2">
                  <li>Provide accurate and complete information during onboarding</li>
                  <li>Maintain up-to-date KYC documentation</li>
                  <li>Promptly notify us of any changes to your business</li>
                  <li>Cooperate with our compliance investigations</li>
                  <li>Implement appropriate controls for your own customers</li>
                </ul>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-[#1E3A5F] mb-4">6. Monitoring and Enforcement</h2>
                <p className="mb-4">
                  Easysend reserves the right to monitor transactions and account activity for compliance 
                  with this policy. We may suspend or terminate accounts that violate this AUP without prior notice.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-[#1E3A5F] mb-4">7. Reporting Violations</h2>
                <p className="mb-4">
                  If you become aware of any violation of this policy, please report it immediately to{' '}
                  <a href="mailto:compliance@easysendservices.com" className="text-[#4FB3DF] hover:underline">
                    compliance@easysendservices.com
                  </a>
                </p>
              </section>
            </div>
          </motion.div>
        </div>
      </main>
      <Footer />
    </div>
  );
};
